import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Pagination,
  Typography, Divider, useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getLogsSettingsAPI } from 'apis/logs/logsAPI';
import dayjs from 'dayjs';
// 공통 타입
type User = {
  id: number;
  email: string;
  username: string;
  name: string;
  phoneNumber: string;
  userType: string | null;
  type: string; // e.g., "NATIVE"
};

type Log = {
  id: number;
  ip: string;
  platform: string; // e.g., "Mac OS X/Mac/Chrome"
  userAgent: string; // Full User-Agent string
  requestedAt: string; // ISO date string
  name: string; // Action name, e.g., "login", "updateNotice"
  action: string; // e.g., "LOGIN", "UPDATE", "DELETE"
  httpMethod: string; // e.g., "POST", "PUT", "DELETE"
  api: string; // API endpoint
  body: string; // Request body
  user: User; // Associated user
};

const actionNames: { [key: string]: string } = {
  SELECT: '조회',
  CREATE: '추가',
  UPDATE: '변경',
  DELETE: '삭제'
}

const workNames: { [key: string]: string } = {
  testEmailTemplate: '이메일 템플릿 테스트',
  createOrUpdateEmailTemplate: '이메일 템플릿 변경',
  updateRemindTime: '리마인드 시간 변경',
  createBusinessPlace: '사업장 항목 추가',
  updateBusinessPlace: '사업장 항목 변경',
  deleteBusinessPlace: '사업장 항목 삭제',
  createDigitalDevice: '디지털기기 항목 추가',
  updateDigitalDevice: '디지털기기 항목 변경',
  deleteDigitalDevice: '디지털기기 항목 삭제',
  createNotice: '공지사항 추가',
  updateNotice: '공지사항 변경',
  deleteNotice: '공지사항 삭제',
  createGroupUsers: '그룹 관리 추가',
  deleteGroupUsers: '그룹 관리 삭제',
  updateVisitorNotification: '외부 사용자 알림 변경',
  updateEmployeeNotification: '임직원 알림 변경',
  uploadFile: '파일 업로드',
  uploadManual: '매뉴얼 업로드',
  uploadFaq: 'FAQ 업로드',
  saveTerms: '이용약관 변경',
  savePrivacy: '개인정보처리방침 변경',
  saveSecurity: '보안서약서 변경',
  changePenalty: '사용자 페널티 변경',
  activeForStatus: '사용자 활성화',
  abortForStatus: '사용자 비활성화',
  initPassword: '사용자 비밀번호 초기화'
}

export default function HistoryScreen() {
  const [logs, setLogs] = useState<Log[]>([]);
  const theme = useTheme();
  // 다국어
  const { t, i18n } = useTranslation(); // useTranslation 훅 사용
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // 페이지 변경 핸들러
  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => setPage(value);

  // 로그 불러오기
  const fetchNotices = async () => {
    try {
      const response = await getLogsSettingsAPI({ page: page });
      setLogs(response.data.logs);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching notices:', error);
    }
  };
  // 언어 바뀔때, 공지사항 불러오기
  useEffect(() => {
    fetchNotices();
  }, [i18n.language, page]);

  return (
    <>
      <Box sx={{ padding: 2 }}>
        <Box
          borderRadius={1}
          display="flex"
          flexDirection="column"
          gap={2}
        >
          <Typography variant="h5" fontWeight="bold">
            {t('menu.history.screen')}
          </Typography>

          <Divider flexItem />
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: theme.palette.contentBlock.background }}>
                <TableCell width="15%" sx={{ fontWeight: 'bold' }}>시간</TableCell>
                <TableCell width="10%" sx={{ fontWeight: 'bold' }}>아이디</TableCell>
                <TableCell width="10%" sx={{ fontWeight: 'bold' }}>이름</TableCell>
                {/*<TableCell width="15%">API</TableCell>*/}
                <TableCell width="15%" sx={{ fontWeight: 'bold' }}>작업</TableCell>
                {/*<TableCell width="5%">동작</TableCell>*/}
                <TableCell width="10%" sx={{ fontWeight: 'bold' }}>IP</TableCell>
                <TableCell width="15%" sx={{ fontWeight: 'bold' }}>플랫폼</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map((log) => (
                <TableRow key={log.id}>
                  <TableCell>{new Date(log.requestedAt).toLocaleString()}</TableCell>
                  <TableCell>{log.user?.username || '알 수 없음'}</TableCell>
                  <TableCell>{log.user?.name || '알 수 없음'}</TableCell>
                  {/*<TableCell>{log.api}</TableCell>*/}
                  <TableCell>{workNames[log.name] || '알 수 없음'}</TableCell>
                  {/*<TableCell>{actionNames[log.action] || '알 수 없음'}</TableCell>*/}
                  <TableCell>{log.ip}</TableCell>
                  <TableCell>{log.platform}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box mt={2} mb={4} display="flex" justifyContent="center">
        <Pagination count={totalPages} page={page} onChange={handlePageChange} color="primary" />
      </Box>
    </>
  );
}
